import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams, HttpHeaders } from '@angular/common/http';
import { FormGroup } from '@angular/forms';
import { FormPackage } from '../../models/df-package';
import { Observable, Observer } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/typeahead-match.class';
import { AuthService } from '../../../../../../../services/auth.service';
import { ComponentService } from '../../../../../../../services/component.service';

@Component({
	selector: 'df-search-box',
	templateUrl: './search-box.component.html',
	styleUrls: ['./search-box.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class SearchBoxComponent implements OnInit {
	@Input() package: FormPackage;
	@Input() form: FormGroup;
	@Input() config: FormGroup;
	@Input() componentData: any;

	search: string;
	SearchResponse: Observable<any>;
	suggestions$: Observable<any>;
	errorMessage: string;
	externalOptions: string;
	queryParameter: string;
	optionField: string;
	searchUrl: string;
	dataKey: string;
	noResult = false;
	selectedOption: any;
	displayValue: string;
	optionFieldResultOnly: boolean;
	placeholder: string;
	isInternal: boolean;

	constructor(private http: HttpClient, private auth: AuthService, private cs: ComponentService) {}

	ngOnInit(): void {
		this.externalOptions = this.package['externalOptions'];
		this.queryParameter = this.package.settings.queryParameter;
		this.placeholder = this.package.settings.placeholder;
		this.optionField = this.package.settings.optionField;
		this.dataKey = this.package.settings.dataKey;
		this.optionFieldResultOnly = this.package.settings.optionFieldResultOnly;
		this.isInternal = this.package.settings.isInternal;

		/* Test values
    this.externalOptions = 'https://api.github.com/search/users';
    this.queryParameter = 'q';
    this.optionField = 'login';
    this.dataKey = 'items';
    */

		if (!this.optionFieldResultOnly) {
			this.displayValue = this.config.controls[this.package.key].value[this.optionField]
				? this.config.controls[this.package.key].value[this.optionField]
				: '';
		} else {
			this.displayValue = this.config.controls[this.package.key].value ? this.config.controls[this.package.key].value : '';
		}

		this.suggestions$ = new Observable((observer: Observer<string>) => {
			observer.next(this.config.get(this.package.key).value);
		}).pipe(
			switchMap((query: string) => {
				let params = new HttpParams();
				if (this.queryParameter) {
					params = params.append(this.queryParameter, query);
					this.searchUrl = this.externalOptions;
				} else {
					this.searchUrl = this.externalOptions + query;
				}

				if (this.isInternal) {
					if (typeof query === 'object') {
						query = query[this.optionField];
					}
					this.searchUrl = this.externalOptions + this.queryParameter + '=' + query;

					const httpOptions = {
						headers: new HttpHeaders({
							'Content-Type': 'application/json',
							'optimove-dm': '1'
						})
					};
					return this.http
						.post(this.searchUrl, { config: JSON.stringify(this.cs.componentData['value']['config']) }, httpOptions)
						.pipe(
							map((data: any) => {
								if (data.status) {
									if (this.dataKey) {
										return data[this.dataKey].filter((res) => res[this.optionField]);
									} else {
										return data.filter((res) => res[this.optionField]);
									}
								} else {
									return [];
								}
							}),
							catchError(this.handleError.bind(this))
						);
				} else {
					return this.http
						.get(this.searchUrl, {
							params: params
						})
						.pipe(
							map((data: any) => {
								if (this.dataKey) {
									return data[this.dataKey].filter((res) => res[this.optionField]);
								} else {
									return data.filter((res) => res[this.optionField]);
								}
							}),
							catchError(this.handleError.bind(this))
						);
				}
			})
		);
	}

	handleError(error: HttpErrorResponse): void {
		if (error.error instanceof ErrorEvent) {
			// A client-side or network error occurred. Handle it accordingly.
			console.error('In call to: "' + this.searchUrl + '" An error occurred:', error.error.message);
		} else {
			// The backend returned an unsuccessful response code.
			// The response body may contain clues as to what went wrong,
			console.error(`Error in call to ${this.searchUrl}. Backend returned code ${error.status}, ` + `body was: ${error.error}`);
		}
	}

	focusSearch() {
		if (this.config.controls[this.package.key].value != '') {
			this.config.controls[this.package.key].setValue(this.displayValue);
		}
	}

	typeaheadNoResults(event: boolean): void {
		this.noResult = event;
		this.selectedOption = 'No Results Found';
	}

	onSelect(event: TypeaheadMatch): void {
		this.noResult = false;
		this.selectedOption = event.item;
		this.displayValue = this.selectedOption[this.optionField];
		this.config.controls[this.package.key].patchValue(this.selectedOption[this.optionField]);
		if (!this.optionFieldResultOnly) {
			this.config.controls[this.package.key].patchValue(this.selectedOption, { emitModelToViewChange: false });
		}
	}
}
